import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { generateUniqueId } from "@/utils/strings"

export const useNotificationStore = defineStore('notificationStore', () => {

  //const notificationList = ref([])
  const isLoading = ref(true)

  const notificationList = ref([])
  const notificationCounter = ref(0)

  const messagesList = ref([])
  const messagesCounter = ref(0)

  const topNotificationList = ref([])
  const topNotificationCounter = ref(0)

  const snackbarList = ref([])
  const snackbarCounter = ref(0)


  async function fetchNotifications(info) {
    isLoading.value = true
    try {
      const response = await $backend(`/notifications/index`, {
        method: 'GET',
      })
      if(response.success) {
        notificationList.value = response.data?.events.notifications
        notificationCounter.value = response.data?.events.counter
        messagesList.value = response.data?.messages.notifications
        messagesCounter.value = response.data?.messages.counter
        topNotificationList.value = response.data?.top.notifications
        topNotificationCounter.value = response.data?.top.counter
        snackbarList.value = response.data?.snackbar.notifications
        snackbarCounter.value = response.data?.snackbar.counter
      }
    } catch (error) {}
    isLoading.value = false

    return notificationList.value
  }

  // notificationId - one id, or an array of ids read together (e.g. every SMS of a client)
  async function readNotification(notificationId, notificationUrl = "") {
    isLoading.value = true

    const response = { success: false, message: '' }

    // BE takes at most 100 ids - the rest stay unread until the next click
    const ids = [notificationId].flat().slice(0, 100)

    try {
      // rand keeps parallel reads from aborting each other (same URL = same abort key); ids stay out of the query, BE reads them from the body only
      response.value = await $backend(`/notifications/read?rand=${generateUniqueId()}`, {
        method: 'POST',
        body: { ids },
      })
      if(response.value?.success && notificationUrl) {
        window.open(notificationUrl, '_blank')
      }
      if(response.value?.success) {
        await fetchNotifications()
      }
    } catch (error) {}
    isLoading.value = false

    return response.value
  }

  // what - "messages" or "events", BE rejects anything else
  async function readAllNotifications(what) {
    isLoading.value = true

    const response = { success: false, message: null }

    try {
      response.value = await $backend(`/notifications/read`, {
        method: 'POST',
        body: {
          all: what,
        },
      })
      if(response.value?.success) {
        if(what === "events") {
          notificationList.value = []
          notificationCounter.value = 0
        }
        if(what === "messages") {
          messagesList.value = []
          messagesCounter.value = 0
        }
      }
    } catch (error) {}
    isLoading.value = false

    return response.value
  }

  // Ids of a client's message notifications (SMS received, visit cancelled by SMS)
  const clientSmsNotificationIds = salonerClientId => messagesList.value
    .filter(item => item.type?.startsWith('message-sms') && String(item.salonerClientId) === String(salonerClientId))
    .map(item => item.id)

  setInterval(() => {
    fetchNotifications().then(data => {})
  }, 5 * 60 * 1000) // Fetch notifications once in 5 minutes

  return { isLoading,
    notificationList,
    notificationCounter,
    messagesList,
    messagesCounter,
    fetchNotifications,
    topNotificationList,
    topNotificationCounter,
    snackbarList,
    snackbarCounter,
    readNotification,
    readAllNotifications,
    clientSmsNotificationIds,
  }
})
